import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { commonEnUS } from './locales/en-US/common';

export const DEFAULT_LOCALE = 'en-US';
export const NAMESPACES = ['common'] as const;

export type Namespace = (typeof NAMESPACES)[number];

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  ns: NAMESPACES as unknown as string[],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  resources: {
    'en-US': {
      common: commonEnUS,
    },
  },
});

export { i18n };
